"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SMALL = exports.EXTRA_SMALL = exports.DEFAULT = void 0;
var EXTRA_SMALL = "2px";
exports.EXTRA_SMALL = EXTRA_SMALL;
var SMALL = "4px";
exports.SMALL = SMALL;
var DEFAULT = "8px";
exports.DEFAULT = DEFAULT;
//# sourceMappingURL=border-radius.js.map